import type { DocumentsAndRequestsFeatureConfig } from './type';

export const documentsAndRequests: DocumentsAndRequestsFeatureConfig = {
    displayCaseType: false,
    documentsPackageDownload: false,
    displayCaseId: true,
    totalFilesForUploadSizeLimitInMBs: 100,
    operationAgnosticSigning: false,
    signingAlwaysVisible: false,
    caseTypeFilterVisible: false,
    caseConfidentialFilterVisible: false,
    temporarilyBypassCapabilities: false,
    overviewFilterText: false,
    overviewFilterProduct: false,
    overviewFilterProductType: false,
    overviewFilterProductTypes: [
        'ACCOUNTS',
        'CARDS',
        'INSURANCES',
        'BUILDINGS',
        'PENSIONS',
        'SECURITIES',
    ],
    overviewFilterCaseType: false,
    overviewFilterCaseTypes: ['CONTRACTS', 'INFORMATIONAL', 'STATEMENTS', 'OTHERS'],
    overviewFilterCaseCategory: false,
    overviewFilterCaseStatus: false,
    overviewFilterCaseStatuses: [
        'FOR_SIGNING',
        'SIGNED',
        'COSIGNING',
        'REJECTED',
        'FOR_DISPLAY',
        'DISPLAYED',
        'CANCELLED',
        'EXPIRED',
        'FOR_UPLOAD',
        'RE_UPLOAD_REQUIRED',
        'PENDING_APPROVAL',
        'CLOSED',
    ],
    productDetailsMenuItem: false,
};
